import React from 'react';

import randomstring from 'uuid/v4';

import NewCommunications from './NewCommunications';
import Answers from './Answers';

import TextField from '@material-ui/core/TextField';
import AttachFile from '@material-ui/icons/AttachFile';
import Timer from '@material-ui/icons/Timer';
import Reply from '@material-ui/icons/Reply';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Delete from '@material-ui/icons/Delete';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Send from '@material-ui/icons/Send';
import Close from '@material-ui/icons/Close';

import ProtectedImg from './ProtectedImg';


import { timeDiference, getCurrentTime } from '../../../functions/time';

class DetailCommunication extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            param: props.param,
            communication: undefined,
            comentario: '',
        };
        props.loadInfoCommunication(props.param);
    }

    static getDerivedStateFromProps(props, state) {
        const { param, communication } = props;

        if (param !== state.param) {
            state.param = param;
            props.loadInfoCommunication(param);
            return state;
        } else if (communication !== state.communication && !!communication.id && communication.id.toString() === param.toString()) {
            state.communication = communication;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };


    handleDelete = (event) => {
        this.props.deleteCommunication(this.state.communication.id)
            .then(() => {
                this.props.history.push('/communications/sent');
            })
            .catch((error) => {
                this.props.showError(error.message, error.type);
            })
    }

    handleSave = (event) => {
        this.props.saveCommunication(this.state.communication)
            .then(() => {
                this.props.history.push('/communications/sent');
            })
            .catch((error) => {
                this.props.showError(error.message, error.type);
            })
    }

    handleReply = (event) => {
        if (this.state.comentario) {
            this.props.sendComment({ id: this.state.communication.id, mensaje: this.state.comentario })
                .then(() => {
                    this.setState({ comentario: '' });
                })
                .catch((error) => {
                    this.props.showError(error.message, error.type);
                })
        }
    }

    exit = () => {
        this.props.history.push('/communications/sent');
    }

    isOk = () => {
        return this.state.communication && this.state.communication.estado > 0;
    }

    render() {
        const { communication, comentario } = this.state;
        const { intl } = this.props;
        const diff = communication && communication.programada ? timeDiference(communication.programada, getCurrentTime()) : '';

        return (
            <div className={'flex_50 bg_white detail_communications overflow_y_scroll showbar'}>
                {(communication && this.isOk()) && (
                    <div className={'flex_full_column padding_borders_flat'}>
                        <div className="flex_auto_row align_center margin_top_24">
                            <div className="flex_full_row align_center ">
                                {communication.estado === 0 && (
                                    <div className="button-message barlow_regular_small c_slate border_slate">
                                        {intl.formatMessage({ id: 'communication_draft' })}
                                    </div>
                                )}
                                {communication.estado === 3 && (
                                    <div className="button-message barlow_regular_small c_pea border_pea">
                                        {intl.formatMessage({ id: 'communication_readed' })}
                                    </div>
                                )}
                                {communication.estado === 4 && (
                                    <div className="button-message barlow_regular_small c_bluish border_bluish">
                                        {intl.formatMessage({ id: 'communication_answered' })}
                                    </div>
                                )}
                                {communication.estado === 5 && (
                                    <div className="button-message barlow_regular_small c_disabled border_disabled">
                                        {intl.formatMessage({ id: 'communication_saved' })}
                                    </div>
                                )}
                                {communication.prioridad === 1 && (
                                    <div className="button-message barlow_regular_small c_lipstick border_lipstick">
                                        {intl.formatMessage({ id: 'communication_text_urgent' })}
                                    </div>
                                )}
                            </div>
                            {communication.estado === 0 && (
                                <div className="flex_auto_row">
                                    <div
                                        className="button-send align_center flex_auto_row margin_right_6"
                                        onClick={this.handleOpenPopupAnswer}
                                    >
                                        <Send className="c_bluish margin_right_6" />
                                        {intl.formatMessage({ id: 'communication_send' })}
                                    </div>
                                    <div
                                        className="button-remove align_center flex_auto_row margin_right_6"
                                        onClick={this.handleDelete}
                                    >
                                        <Delete className="c_lipstick hand" />
                                        {intl.formatMessage({ id: 'communication_remove' })}
                                    </div>
                                </div>
                            )}
                            {communication.estado === 1 && (
                                <div className="flex_auto_row">
                                    <div
                                        className="button-remove align_center flex_auto_row margin_right_6"
                                        onClick={this.handleDelete}
                                    >
                                        <Delete className="c_lipstick hand" />
                                        {intl.formatMessage({ id: 'communication_remove' })}
                                    </div>
                                </div>
                            )}
                            {communication.estado >= 2 && communication.estado < 5 && (
                                <div className="flex_auto_row">
                                    <div
                                        className="button-save align_center flex_auto_row margin_right_6 hand"
                                        onClick={this.handleSave}
                                    >
                                        <SaveAlt className="c_disabled margin_right_6" />
                                        {intl.formatMessage({ id: 'communication_save' })}
                                    </div>
                                </div>
                            )}
                            <Close className="c_disabled margin_left_6 margin_right_6 hand" onClick={this.exit} />
                        </div>
                        <div className="flex_auto_row align_center margin_top_24">
                            <span className="flex_full_row  barlowsemicondensed_bold c_slate">
                                {communication.asunto}
                            </span>
                        </div>
                        {communication.enviada && (
                            <div className="flex_auto_row align_center margin_top_8">
                                <p className="flex_full_row barlow_italic_medium c_disabled">
                                    {communication.enviada}
                                </p>
                            </div>
                        )}
                        {(communication.programada && diff !== '00 s') && (
                            <div className="flex_auto_row align_center margin_top_8">
                                <CalendarToday className="c_disabled margin_right_6 communications_icon" />
                                <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2">
                                    {intl.formatMessage({
                                        id: 'communication_remaining_time_sent',
                                    })}
                                </span>
                                <p className="flex_auto_row barlow_regular_small c_slate">
                                    {communication.programada.substring(0, communication.programada.length - 3)}
                                </p>
                            </div>
                        )}
                        {(communication.limite && timeDiference(communication.limite, getCurrentTime()) !== '00 s') && (
                            <div className="flex_auto_row align_center">
                                <Timer className="c_disabled margin_right_2 communications_icon" />
                                <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2">
                                    {intl.formatMessage({ id: 'communication_remaining_time' })}
                                </span>
                                <p className="flex_auto_row barlow_regular_small c_slate">
                                    {communication.limite.substring(0, communication.limite.length - 3)}
                                </p>
                            </div>
                        )}

                        <div className="flex_auto_column margin_top_8">
                            <p className="flex_full_row barlow_regular_small c_slate">
                                {intl.formatMessage({ id: 'form_field_description' })}
                            </p>
                            <div
                                className="flex_full_row bg_black_6 shadow_left_only ql-editor-show "
                                dangerouslySetInnerHTML={{ __html: communication.cuerpo }}
                            ></div>
                        </div>

                        {communication.adjuntos && (
                            <div className="flex_auto_column margin_top_8">
                                <div className="flex_auto_row align_center">
                                    <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                    <p className="flex_full_row barlow_regular_small c_slate">
                                        {intl.formatMessage({ id: 'attach' })}
                                    </p>
                                </div>
                                <div className="flex_auto_column margin_top_8">
                                    {communication.adjuntos.length > 0 &&
                                        communication.adjuntos.map((a) => {
                                            return (
                                                <ProtectedImg
                                                    {...this.props}
                                                    key={`thumbnail-${communication.id}-${a.id}`}
                                                    communication
                                                    id={a.id}
                                                    name={a.nombre}
                                                    parent={communication.id}
                                                    src={`${process.env.REACT_APP_API_COMMUNICATIONS}/${communication.id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                    download={`${process.env.REACT_APP_API_COMMUNICATIONS}/${communication.id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                />)
                                        })
                                    }
                                </div>
                            </div>

                        )}

                        {communication.destinatarios &&
                            communication.destinatarios.nodos &&
                            communication.destinatarios.nodos.map((n) =>
                                <Answers {...this.props} key={randomstring()} nodo={n} />)
                        }

                        <div className="flex_auto_column margin_top_8">
                            <div className="flex_auto_row align_center">
                                <div className={'bubbly margin_right_6'}>
                                    {communication.comentarios && communication.comentarios.length > 0 ? communication.comentarios.length : 0}
                                </div>
                                <p className="flex_full_row barlow_regular_small c_slate">
                                    {intl.formatMessage({ id: 'form_field_comment' })}
                                </p>
                            </div>
                            {communication.comentarios && communication.comentarios.length > 0 && (
                                <ul className="padding_left_24 margin_bottom_5">
                                    {communication.comentarios.map((c) => {
                                        return (
                                            <li
                                                key={randomstring()}
                                                className="communication-comments-point flex_auto_column"
                                            >
                                                <div className="flex_auto_row align_center">
                                                    <span className="flex_full_row barlowsemicondensed_semibold_link c_bluish">
                                                        {c.remitente}
                                                    </span>
                                                    <span className="flex_auto_row barlow_regular_subtitle_small c_disabled nowrap">
                                                        {c.fecha}
                                                    </span>
                                                </div>
                                                <div className="flex_auto_row barlow_regular_subtitle margin_bottom_24 c_slate margin_top_8">
                                                    {c.mensaje}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            <div className="flex_auto_row padding_left_24 align_center">
                                <TextField
                                    id="comentario"
                                    name="comentario"
                                    label={intl.formatMessage({ id: 'comments_drawer' })}
                                    fullWidth
                                    className="margin_bottom_12 padding_top_24"
                                    value={comentario}
                                    onChange={this.handleChange}
                                />
                                <Reply className="c_bluish margin_left_6 hand" onClick={this.handleReply} />
                            </div>
                        </div>


                    </div>
                )}
                {(communication && !this.isOk()) &&
                    <NewCommunications {...this.props} id={this.props.param} />
                }
            </div>
        );
    }
}

export default DetailCommunication;



// WEBPACK FOOTER //
// ./src/components/complex/communications/DetailCommunication.js